var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card is-orders"},[_c('div',[_c('span',[_vm._v("سفارش‌های من")]),_c('strong',[_vm._v(_vm._s(_vm.totalCount))]),_c('small',[_vm._v("سفارش ثبت‌شده")])]),_c('img',{attrs:{"src":require("../../../../public/order.webp"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }